"use client"

import { useEffect, useState } from "react";

import { ShareButton } from "./share-button";

const PostShare = ({ title }: { title: string }) => {

  const [currentUrl, setCurrentUrl] = useState<string>("")
  
  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href)
    }
  }, [])

  return (
    <div className="border border-gray-200 rounded-lg p-6">
      <h3 className="text-xs text-gold uppercase mb-3 font-bold">Compartilhe este artigo</h3>
      <div className="flex space-x-4">
        <ShareButton title={title} url={currentUrl}  />
      </div>
    </div>
  );
}
 
export default PostShare;